/**
 * @typedef {Object} Category
 * @property {string} id - The unique identifier.
 * @property {string} label - The display label.
 */

/**
 * @type {Category[]}
 * Get category types from SSR'd JSON Array
 */
const categories = document.getElementById('course-categories-ssr') ? JSON.parse(document.getElementById('course-categories-ssr').dataset.settings) : [];


export const COURSE_CATEGORIES = categories;
